import React, { useEffect, useState } from 'react';
import { fetchVipConfig } from '../services/api';
import { Field, PageTitle, WriteOffNote, useSave, useWriteLive } from './StaffList';

/**
 * Set VIP Period and Set VIP Overlay: one row each in the configuration table (Azure exit WS8).
 * Reads sql01.configuration. Saving is off until the screen's flag is on.
 */
export default function VipSetting({ title, feature, action, fieldName, intro, ask, options, saveLabel }) {
  const live = useWriteLive(feature);
  const [value, setValue] = useState(null);
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);
  const { save, saving, error: saveError } = useSave(() => {});

  useEffect(() => {
    let on = true;
    fetchVipConfig(fieldName)
      .then((r) => {
        if (!on) return;
        // Stored text can differ in case from the choices: VIP_OVERLAY holds 'NO'.
        const stored = (r[0] && r[0].value) || '';
        const match = options.find(([v]) => v.toLowerCase() === stored.trim().toLowerCase());
        setValue(match ? match[0] : stored);
      })
      .catch((e) => { if (on) setError(e.message); });
    return () => { on = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldName]);

  const submit = async () => { if (value) setSaved(!!(await save(action, { value }))); };

  return (
    <div>
      <PageTitle>{title}</PageTitle>
      <WriteOffNote live={live} what="Changes" />
      <div className="card">
        <div className="modal-body">
          <div className="staff-hint">{intro}</div>
          {error && <div className="staff-msg staff-msg-error">Error: {error}</div>}
          {value === null && !error && <div className="staff-msg">Loading...</div>}
          {value !== null && (
            <Field label={ask}>
              <select className="form-select" disabled={!live} value={value} onChange={(e) => { setSaved(false); setValue(e.target.value); }}>
                <option value="">Select</option>
                {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                {value && !options.some(([v]) => v === value) && <option value={value}>{value}</option>}
              </select>
            </Field>
          )}
          {saveError && <div className="staff-msg staff-msg-error">{saveError}</div>}
          {saved && !saveError && <div className="staff-msg">Successfully updated.</div>}
          <button type="button" className="btn btn-primary" disabled={!live || saving || !value} onClick={submit}>{saveLabel}</button>
        </div>
      </div>
    </div>
  );
}
